/* data-product-json */
var level = 0;

var dataProductJsonString = $('script[data-product-json]').text();
var dataProductJson = JSON.parse(dataProductJsonString);
var variants_json_constructor = [];
dataProductJson.variants.forEach(function(variant)
{   
    if (variant.available != false)
    {
        variants_json_constructor.push(variant.title);
    }
});
const variants_json = variants_json_constructor;

var discount = 0;

var dataProductMetaJsonString = document.querySelector('script[data-product-meta-json]').innerHTML.trim();
var dataProductMetaJsonString = JSON.parse(dataProductMetaJsonString);
var stickiesStaging = dataProductMetaJsonString.metafields.custom.stickies_staging;
var stickiesLive = dataProductMetaJsonString.metafields.custom.stickies_live;
var use_staging_stickies = dataProductMetaJsonString.use_staging_stickies;

var stickiesMeta = stickiesLive;
if(use_staging_stickies && stickiesStaging != ""){
    stickiesMeta = stickiesStaging;
}
stickiesMeta.forEach(function(tag)
{
    //console.log("tag", tag)
    // if (tag == 'Discount_15_OFF_Sticker'){
    //     discount = discount+.85;
    // } 
    if (tag == 'sticker__Low Stock! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__Best Seller! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__New Prints! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__Back in Stock! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__New Product! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__Bundle & Save! 20% OFF'){
        discount = discount+.80;
    } else if (tag == 'sticker__Best Deal! 25% OFF'){
        discount = discount+.75;
    } else if (tag == 'sticker__Best Deal! 30% OFF'){
        discount = discount+.70;
    } else if (tag == 'sticker__Best Deal! 40% OFF'){
        discount = discount+.60;
    } else if (tag == 'sticker__Best Deal! 50% OFF'){
        discount = discount+.50;
    }
});

function cecilInstallment()
{
    var current_currency = $('meta[property="og:price:currency"]').attr('content');
    var priceEl = $('.product-detail__price.product-price span.theme-money');

    //var string_variant_price = $('.product-detail__price.product-price span.theme-money').html();    

    if (current_currency == "GBP" && priceEl.length && priceEl.html())
    {
        var string_variant_price = priceEl.html();
        var currency_symbol = "£";
        var variant_price = parseFloat(string_variant_price.replace("£", "").replace("$", "")).toFixed(2);
    }
    else if (current_currency == "EUR" && priceEl.length && priceEl.html())
    {
        var string_variant_price = priceEl.html();
        var currency_symbol = "€";
        var variant_price = parseFloat(string_variant_price.replace("€", "").replace("$", "").replace(",", ".")).toFixed(2);
    }
    else
    {
        if(priceEl.length && priceEl.html()){
            var string_variant_price = priceEl.html();
            var currency_symbol = "$";
            var variant_price = parseFloat(string_variant_price.replace("$", "").replace("$", "")).toFixed(2); 
        }
        
    }
    var installment = parseFloat(variant_price)/4;
    if (current_currency == "EUR")
    {
        installment = installment.toFixed(2).toString().replace(".", ",");
    }
    $('#cecil-widget .sezzle-payment-amount.sezzle-button-text').html(currency_symbol+installment);
}

function scopeCalculation()
{
    var opt1 = $("#SingleOptionSelector-1").length;
    var opt2 = $("#SingleOptionSelector-2").length;
    if (opt2 >0){
        level = 2;
    }else if(opt1 >0){
        level = 1;
    }
    return level;
}

function indexOverDOM(){
    for (let index_wrapper = 0; index_wrapper < 3; index_wrapper++) {
        $(".selector-wrapper[data-attribute='"+index_wrapper+"'] .clickyboxes li a" ).each(function(i) {
            $(this).attr("index-number",i);
        });
    }
}

function hideUnavailable(handle, variant_dom, variants_json)
{
    var present =  (variants_json.indexOf(variant_dom) > -1);
    if (present == false)
    {
        $(handle).addClass("hidden");
    }
    else
    {
        $(handle).removeClass("hidden");
    }
}

function reDraw(variants_json)
{
    scopeCalculation();
    if (level == 2)
    {
        /*
        value_option_dom_0 = $("#clickyboxes-SingleOptionSelector-0 li a.active").attr("data-value");
        value_option_dom_1 = $("#clickyboxes-SingleOptionSelector-1 li a.active").attr("data-value");
        value_option_dom_2 = $("#clickyboxes-SingleOptionSelector-2 li a.active").attr("data-value");
        $("#clickyboxes-SingleOptionSelector-2 li a").each(function()
        {
            var data_value = $(this).attr("data-value");
            variant_dom = value_option_dom_0+" / "+value_option_dom_0+" / "+data_value;
            hideUnavailable(".clickyboxes li a[data-value='"+data_value+"']", variant_dom, variants_json);
        });
        */
    }
    else if (level == 1)
    {
        value_option_dom_0 = $("#clickyboxes-SingleOptionSelector-0 li a.active").attr("data-value");
        value_option_dom_1 = $("#clickyboxes-SingleOptionSelector-1 li a.active").attr("data-value");
        $("#clickyboxes-SingleOptionSelector-1 li a").each(function()
        {
            var data_value = $(this).attr("data-value");
            variant_dom = value_option_dom_0+" / "+data_value;
            hideUnavailable(".clickyboxes li a[data-value='"+data_value+"']", variant_dom, variants_json);
        });
    }
}
let option_value_selected = '';

function setOptionValueSelected(option_value){
    option_value_selected = String(option_value);
}

////////////// old code /////////////////////////////
// function compareAtPricePlusPrice(option_value){
//     scopeCalculation();
//     if (level > 0)
//     {
//         if (option_value_selected == option_value){
//             return
//         }else{
//             option_value_selected = String(option_value);
//             if (discount > 0){
//                 var compareAtPrice_0 = $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').text();
//                 if(compareAtPrice_0.indexOf('$') > -1) {
//                     var currency_code = 'USD';
//                     var currency_symbol = '$';
//                 }
//                 else if(compareAtPrice_0.indexOf('£') > -1) {
//                     var currency_code = 'GBP';
//                     var currency_symbol = '£';
//                 }
//                 else if(compareAtPrice_0.indexOf('€') > -1) {
//                     var currency_code = 'EUR';
//                     var currency_symbol = '€';
//                 }
//                 var salePrice_1 = compareAtPrice_0.replace('$', '').replace('£', '').replace('€', '');
//                 var salePrice_2 = parseFloat(salePrice_1).toFixed(2);
//                 var salePrice_3 = salePrice_2.replace(',', '.');
//                 var salePrice_4 = parseFloat(salePrice_3) * discount;
//                 var salePriceCreated = salePrice_4.toFixed(2);
//                 if (currency_code == 'EUR') {
//                     salePriceCreated = parseFloat(salePriceCreated)+.67;
//                     salePriceCreated = salePriceCreated.toFixed(2);
//                     salePriceCreated = salePriceCreated.toString().replace('.', ',');
//                 }
//                 var compareAtPriceCreated = '<span class="theme-money mono">'+compareAtPrice_0+'</span>';
//                 $('.product-detail__price.product-price.mono span.product-price__compare').removeClass('hide');
//                 $('.product-detail__price.product-price.mono span.product-price__compare').html(compareAtPriceCreated);
//                 $('.product-detail__price.product-price.mono span[data-product-price]').addClass('product-price__reduced');
//                 $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').addClass('mono');
//                 $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').text(currency_symbol+salePriceCreated);
//             }
//         }
//     }
// }

function compareAtPricePlusPrice(option_value){
    scopeCalculation();
    if (level > 0)
    {
        if (option_value_selected == option_value){
            return
        }else{
            option_value_selected = String(option_value);
            if (discount > 0){
                var compareAtPrice_default = $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').text();
                var compareAtPrice_0 = $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').text();
                if(compareAtPrice_0.indexOf('$') > -1) {
                    var currency_code = 'USD';
                    var currency_symbol = '$';
                }
                else if(compareAtPrice_0.indexOf('£') > -1) {
                    var currency_code = 'GBP';
                    var currency_symbol = '£';
                }
                else if(compareAtPrice_0.indexOf('€') > -1) {
                    var currency_code = 'EUR';
                    var currency_symbol = '€';
                }else {
                    var currency_code = Shopify.currency.active;
                    var currency_symbol = theme.moneyFormat;
                    currency_symbol = currency_symbol.replace('{{amount}}', '').replace('{{amount_no_decimals}}','');
                    compareAtPrice_0 = compareAtPrice_0.replace(currency_symbol, '')
                }

                var salePrice_1 = compareAtPrice_0.replace('$', '').replace('£', '').replace('€', '');
                console.log("salePrice_1 ",salePrice_1)

                if (currency_code == 'EUR') {
                    salePriceCreated = parseFloat(salePrice_1.replace(',', '.')) * discount;
                    console.log("parseFloat(salePrice_1.replace(',', '.')) * discount ",parseFloat(salePrice_1.replace(',', '.')) +" * " +discount, parseFloat(salePrice_1.replace(',', '.'))*discount);                    
                    salePriceCreated = parseFloat(salePriceCreated);
                    
                    salePriceCreated = salePriceCreated.toFixed(2);
                    salePriceCreated = salePriceCreated.toString().replace('.', ',');
                    console.log("salePriceCreated... ",salePriceCreated)
                }else {
                    var salePrice_3 = salePrice_1.replace(',', '');
                    var salePrice_4 = parseFloat(salePrice_3) * discount;
                    var salePriceCreated = salePrice_4.toFixed(2);
                    salePriceCreated = parseFloat(salePriceCreated).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    console.log(salePriceCreated); 
                }
                var compareAtPriceCreated = '<span class="theme-money mono">'+compareAtPrice_default+'</span>';
                
                $('.product-detail__price.product-price.mono span.product-price__compare').removeClass('hide');
                $('.product-detail__price.product-price.mono span.product-price__compare').html(compareAtPriceCreated);
                $('.product-detail__price.product-price.mono span[data-product-price]').addClass('product-price__reduced');
                $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').addClass('mono');
                $('.product-detail__price.product-price.mono span[data-product-price] .theme-money').text(currency_symbol+salePriceCreated);
                
                
            }
        }
    }
}

$(document).ready(function()
{
    setOptionValueSelected($("#clickyboxes-SingleOptionSelector-0 li a.active").attr("data-value"));

    cecilInstallment();

    indexOverDOM();
    
    reDraw(variants_json);

    $("#clickyboxes-SingleOptionSelector-0 li a").on("click",function()
    {
        setTimeout(function(){
            reDraw(variants_json);
            $("#clickyboxes-SingleOptionSelector-1 li a:not(.hidden)").first().click();
        });

        setTimeout(() => {
            compareAtPricePlusPrice($(this).attr("data-value"));
        },50);
    });

});